import { Collapse } from "antd";
import styled from "styled-components";

export const StyledCollapse = styled(Collapse)`
    border-radius: 0;
    border: none;
`;

export const StyledPaymentsContainer = styled.div`
    background: ${({ theme }) => theme.secondaryBackground};
    padding: 12px;
    overflow-y: auto;
    border-radius: 8px;
`;

export const StyledActionsContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;
